import { Box, IconButton, Typography } from "@mui/material";
import { toToman } from "../../utils/Utils";
import { ReactComponent as EditIcon } from "../../assets/icons/edit-pencil-colored.svg";
import { useState } from "react";
import { DeleteContractBottomSheet } from "./DeleteContractBottomSheet";
import moment from "moment-jalaali";

const CardItem = (props) => {
  const { title, value, first } = props;
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        borderLeft: !first && ((theme) => `1px solid ${theme.palette.grey[6]}`),
      }}
    >
      <Typography variant="subtitle1" color="secondary.main">
        {title}
      </Typography>
      <Box mt={1}>{value}</Box>
    </Box>
  );
};

function ContractCard({ sx = [], ...props }) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const { contract, getUserContract } = props;
  return (
    <Box
      onClick={() => {}}
      sx={{
        width: "100%",
        p: "24px",
        borderRadius: "10px",
        boxShadow: (theme) => theme.shadows[3],
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
    >
      <IconButton
        onClick={() => {
          setOpenDrawer(true);
        }}
        sx={{ position: "absolute", top: 16, right: 16 }}
      >
        <EditIcon width={16} height={17} />
      </IconButton>
      <Box sx={{ display: "flex" }}>
        <img width={40} height={40} src={contract.bank.logoUrl} />
        <Box
          sx={{
            ml: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="body2" color="secondary.dark">
            {contract.bank.name}
          </Typography>
          <Typography component={"div"} variant="subtitle1" color="grey.4">
            سقف برداشت:{" "}
            <Typography
              display={"inline"}
              variant="subtitle1"
              color="grey.2"
            >{`${toToman(contract.limit)} تومان`}</Typography>
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", mt: 3 }}>
        {[
          {
            title: "تاریخ شروع",
            value: (
              <Typography variant="subtitle1" color="grey.2">
                {moment(contract.createdAt).format("jYYYY/jMM/jDD")}
              </Typography>
            ),
          },
          {
            title: "تاریخ انقضا",
            value: (
              <Typography variant="subtitle1" color="grey.2">
                {moment(contract.expirationDate).format("jYYYY/jMM/jDD")}
              </Typography>
            ),
          },
          {
            title: "تا پایان قرارداد",
            value: (
              <Typography variant="subtitle1" color="grey.2">
                {`${contract.remainingDays} روز`}
              </Typography>
            ),
          },
        ].map((item, index) => {
          return (
            <CardItem
              key={item.title}
              title={item.title}
              value={item.value}
              first={index === 0}
            />
          );
        })}
      </Box>
      <DeleteContractBottomSheet
        open={openDrawer}
        setOpen={setOpenDrawer}
        id={contract.id}
        getUserContract={getUserContract}
      />
    </Box>
  );
}

export default ContractCard;
